import {
    alpha,
    Button,
    Divider,
    Stack,
    styled,
    Typography,
} from "@mui/material";

import { useGetPublicDomainConfigQuery } from "@callveriq/redux/services/domain/domain.service";
import { baseUrl } from "@apis/axiosInstance";
import GoogleSvg from "@callveriq/components/svg/GoogleSvg";
import OutlookSvg from "@callveriq/components/svg/OutlookSvg";
import JumpCloudSvg from "@callveriq/components/svg/JumpCloudSvg";
import FlipkartSvg from "@callveriq/components/svg/FlipkartSvg";
import { CyberArkSvg } from "@callveriq/components/svg/CyberArkSvg";
import ConcentrixSvg from "@callveriq/components/svg/ConcentrixSvg";

const SsoButton = styled(Button)(({ theme }) => ({
    borderRadius: "100%",
    border: `1px solid ${alpha(theme.palette.textColors["999"], 0.2)}`,
    height: "48px",
    minWidth: "48px",
    background:
        "linear-gradient(0deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.10) 100%), #FFF",
    boxShadow: "2px 2px 12px 0px rgba(51, 51, 51, 0.10)",
    color: theme.palette.textColors["333"],
    "& .MuiButton-icon": {
        margin: 0,
    },
    padding: 0,
}));

export const SsoOptions = () => {
    const { data: domainConfig } = useGetPublicDomainConfigQuery();

    const getUri = (provider: string) => {
        return `${baseUrl}/app/tpsignup/${provider}/`;
    };

    const ssoProviders = domainConfig?.getSsoProviders() ?? [];

    return (
        ssoProviders.length > 0 && (
            <>
                <Divider>
                    <Typography variant="small" className="font-semibold">
                        OR
                    </Typography>
                </Divider>
                <Stack direction="row" spacing={2} justifyContent="center">
                    {ssoProviders.map((provider) => {
                        return (
                            <SsoButton
                                href={getUri(provider)}
                                className="flex items-center justify-center"
                                key={provider}
                            >
                                {provider === "google" ? (
                                    <GoogleSvg />
                                ) : provider === "outlook" ? (
                                    <OutlookSvg />
                                ) : provider === "jumpcloud" ? (
                                    <JumpCloudSvg />
                                ) : provider === "flipkart" ? (
                                    <FlipkartSvg />
                                ) : provider === "cyberark" ? (
                                    <CyberArkSvg />
                                ) : provider === "azure" ? (
                                    <ConcentrixSvg />
                                ) : null}
                            </SsoButton>
                        );
                    })}
                </Stack>
            </>
        )
    );
};
